import {
  ref, set, push, get, query, orderByChild, equalTo, serverTimestamp
} from "firebase/database";
import { db } from "./firebase";

import { v4 as uuidv4 } from "uuid";
import { EventsCities } from "../Data/EventsData";
import { sendReplayMail } from "./mailbox";

const EventixPath = "leads";
const SupportPath = "tickets";
const NewsLatterPath = "newsletter";
const AdminPath = "admin";

export const submitEventixInquiry = async (formData) => {
  const inquiryId = uuidv4();
  const timestamp = new Date().toISOString();

  // 1. Find State and Country from EventsCities based on the selected city
  const cityData = EventsCities.find((item) => item.city === formData.city);

  // 2. Logic for Priority
  let priority = "normal";
  if (formData.budget === "1 Cr +") {
    priority = "extreme";
  } else if (formData.budget === "20 Lakh - 1 Cr") {
    priority = "high";
  } else if (formData.budget === "5 - 20 Lakh") {
    priority = "mid";
  }

  const enrichedData = {
    id: inquiryId,
    userId: "new_user",
    // Contact Info
    fullName: formData.fullName,
    email: formData.email,
    phone: formData.phone,

    // Event Specifics
    eventType: formData.eventType,
    eventDate: formData.date,
    guestCount: Number(formData.guests),
    message: formData.message || "No special requirements.",

    // Location Details (Filtered)
    city: formData.city,
    state: cityData?.state || "Unknown",
    country: cityData?.country || "Unknown",

    // Budget & Priority
    budget: formData.budget,
    priority: priority,

    // Meta Data
    status: "unseen",
    createdAt: timestamp,
    updatedAt: timestamp,
    userAgent: navigator.userAgent,
    platformSource: "Eventix_Lead_Generation",
  };

  try {
    const leadRef = ref(db, `${EventixPath}/${inquiryId}`);
    await set(leadRef, enrichedData);
    await sendReplayMail(formData.fullName, formData.email)
    return {
      success: true,
      message: "Event Inquiry Has Been Submitted",
      id: inquiryId,
    };
  } catch (error) {
    console.error("Event Inquiry Submission Error:", error);
    return {
      success: false,
      message: "Submission failed. Please try again.",
    };
  }
};

export const submitSupportInquiry = async (formData) => {
  const ticketId = `TIC-${uuidv4()}`;
  const timestamp = new Date().toISOString();
  const supportTicket = {
    ticketId,
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    subject: formData.subject,
    message: formData.message,

    // Administrative logic
    status: "open",
    priority: (formData.subject === "Refund Request" || formData.subject === "Cancellation") ? "high" : "normal",
    createdAt: timestamp,
    platform: "Eventix_Web_Support"
  };
  try {
    const ticketRef = ref(db, `${SupportPath}/${ticketId}`);
    await set(ticketRef, supportTicket);
    return {
      success: true,
      message: `Support ticket ${ticketId} created successfully.`,
      ticketId: ticketId
    };
  } catch (error) {
    console.error("Support Submission Error:", error);
    return {
      success: false,
      message: "Our support servers are temporarily unreachable. Please try again later."
    };
  }
};

export const subscribeToNewsletter = async (email) => {
  if (!email) return { success: false, message: "Email is required" };
  const cleanEmail = email.toLowerCase().trim();
  try {
    const newsletterRef = ref(db, NewsLatterPath);
    const emailQuery = query(newsletterRef, orderByChild("email"), equalTo(cleanEmail));
    const snapshot = await get(emailQuery);
    if (snapshot.exists()) {
      return {
        success: false,
        message: "You are already part of our guest list!"
      };
    }
    await push(newsletterRef, {
      email: cleanEmail,
      subscribedAt: serverTimestamp(),
      status: "active",
      source: "Eventix_Footer"
    });
    return {
      success: true,
      message: "Thank you! You've been added to our guest list."
    };
  } catch (error) {
    console.error("Newsletter Error:", error);
    return {
      success: false,
      message: "Connection failed. Please try again later."
    };
  }
};  